import React from "react";
import styled from "styled-components";

const Wrapper = styled.div<{ image: string }>`
	width: 80px;
	height: 80px;
	border-radius: 100%;
	${(props) => props.theme.layout.full_image(props.image)};
	display: inline-block;
	border: 1px solid white;
`;
const Avatar: React.FC<{ image: string }> = ({ image }) => {
	return <Wrapper image={image} />;
};

export default Avatar;
